import script from "./MobileLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileLayout.vue?vue&type=script&setup=true&lang=js"

import "./MobileLayout.vue?vue&type=style&index=0&id=68dfcf84&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68dfcf84"]])

export default __exports__